export const LAUNCH_MONITOR = 'launchMonitorData';
export const FORCE_PLATE = 'forcePlate';
export const HITTING_DEVICE_SENSOR = 'hittingDeviceSensor';
export const ATTRIBUTES = 'attributes';
export const NESTED_ATTRIBUTES = 'attributes.Attribute';
export const KEY_FRAME_DATA = 'keyFrameData';
export const FULL_MOTION_METRICS = 'fullMotionMetrics';